import {useField} from "formik";
import BasicError from "./BasicError";

const FormikError = (props) => {
    const [, meta] = useField(props);

    return meta.touched && meta.error && typeof(meta.error) === "string" ? <BasicError>{meta.error}</BasicError> : null;
}

export default FormikError;